import { AddAnotherContainer as AddAnother } from './AddAnotherContainer';

export default AddAnother;
